/**
 * Utility functions for formatting data in the Master Dashboard
 */

/**
 * Format a number as Brazilian currency (BRL)
 * @param {number} value - The number to format
 * @returns {string} - Formatted currency string
 */
export const formatCurrency = (value) => {
  if (value === undefined || value === null) return "R$ 0,00";
  
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
};

/**
 * Format a number with thousand separators
 * @param {number} value - The number to format
 * @returns {string} - Formatted number string
 */
export const formatNumber = (value) => {
  if (value === undefined || value === null) return "0";
  
  return new Intl.NumberFormat('pt-BR').format(value);
};

/**
 * Format a percentage value
 * @param {number} value - The percentage value
 * @returns {string} - Formatted percentage string
 */
export const formatPercentage = (value) => {
  if (value === undefined || value === null) return "0%";
  
  return `${value}%`;
};
